import { createContext, useContext } from 'react';

interface PanelContextValue {
  panelId: string;
  isFocused: boolean;
  title?: string;
  setTitle?: (panelId: string, title: string) => void;
}

const PanelContext = createContext<PanelContextValue | undefined>(undefined);

export function PanelProvider({
  children,
  panelId,
  isFocused,
  title,
  setTitle
}: {
  children: React.ReactNode;
  panelId: string;
  isFocused: boolean;
  title?: string;
  setTitle?: (panelId: string, title: string) => void;
}) {
  return (
    <PanelContext.Provider value={{ panelId, isFocused, title, setTitle }}>
      {children}
    </PanelContext.Provider>
  );
}

export function usePanelContext() {
  const ctx = useContext(PanelContext);
  if (!ctx) {
    throw new Error('usePanelContext must be used within a PanelProvider');
  }
  return ctx;
}
